import React from "react";
import { useCallback } from "react";
import XtLocale from "../Locale";

/** SSR 或 Locale.init 尚未执行时 XtLocale.intl 可能为空，避免解构崩溃 */
function noopFormatMessage(descriptor, values, opts) {
  if (!descriptor) return "";
  if (descriptor.defaultMessage != null && String(descriptor.defaultMessage) !== "") {
    return String(descriptor.defaultMessage);
  }
  return descriptor.id != null ? String(descriptor.id) : "";
}

const useTranslation = () => {
  const formatMessage = XtLocale.intl?.formatMessage ?? noopFormatMessage;

  const translation = useCallback(
    (id, values = {}) => {
      if (!id) return "";
      let message = formatMessage({ id }, values, { ignoreTag: true });
      if (typeof message !== "string") message = message != null ? String(message) : "";
      // 当前语言缺失时回退英语文案，避免页面上直接露出 key
      if (message === id) {
        const enFallback = XtLocale.messageMap?.en?.[id];
        if (enFallback) {
          message = formatMessage({ id, defaultMessage: enFallback }, values, { ignoreTag: true });
        }
      }
      if (message.startsWith("$t(")) {
        const id2 = message.substring(3, message.length - 1);
        message = formatMessage({ id: id2 }, values, { ignoreTag: true });
      }
      return message;
    },
    [formatMessage],
  );
  translation.t = translation;

  return translation;
};

//react-i18next:Trans
const Trans = ({i18nKey,values,components})=>{
  if(typeof window == "undefined")
    return null;
  const t = useTranslation();
  var message = t(i18nKey, values);
  if(typeof window == "undefined")
  {
    return React.createElement(React.Fragment,null,[message]);
  }
  for(var key in components)
  {
    message = message.replace(new RegExp("<"+key+">",'g'),"<TAG"+key+">").replace(new RegExp("</"+key+">",'g'),"</TAG"+key+">")
  }
  var children = [];
  var temp = document.createElement("div");
  temp.innerHTML = message;
  for(var i=0;i<temp.childNodes.length;++i)
  {
    var child = temp.childNodes[i];
    if(child.nodeType == 3)
      children.push(child.textContent);
    else if(child.tagName && child.tagName.startsWith("TAG"))
    {
      for(var key in components)
      {
        if(key == child.tagName.substr(3))
        {
          children.push(React.cloneElement(components[key],null,child.innerText));
          break;
        }
      }
    }
  }
  return React.createElement(React.Fragment,null,children);
}

//react-intl:useIntl,FormattedMessage
const useIntl = () => {
  return XtLocale.intl || { formatMessage: noopFormatMessage, locale: "en", code: "en" };
};
const FormattedMessage = (props)=>{
  var intl = XtLocale.intl;
  if (!intl) {
    var fbId = props.id, fbDefault = props.defaultMessage;
    return React.createElement(React.Fragment, null, fbDefault != null ? fbDefault : fbId);
  }
  var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? React.Fragment : _a;
  var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
  var descriptor = { id: id, description: description, defaultMessage: defaultMessage };
  var nodes = formatMessage(descriptor, values, {
      ignoreTag: ignoreTag,
  });
  if (typeof children === 'function') {
      return children(Array.isArray(nodes) ? nodes : [nodes]);
  }
  if (Component) {
      return React.createElement(Component, null, React.Children.toArray(nodes));
  }
  return React.createElement(React.Fragment, null, nodes);
}
export default useTranslation;
export {Trans,useIntl,FormattedMessage}